<template>
    <div ref="container" class="video-container">
        <!-- :style="{'width':windowWidth+'px','height':windowHeight+'px'}" -->
      <video ref="video" autoplay playsinline></video>
      <!-- :style="{'opacity':showVideo?1:0}" -->
      <canvas ref="canvas" v-show="!isCompleted"></canvas>
      <!-- <div class="alert">
        <div>leftWrist--{{leftWrist}}</div>
        <div>rightWrist--{{rightWrist}}</div>
      </div> -->
    </div>
  </template>
  
  <script>
  import * as tf from '@tensorflow/tfjs';
  import * as poseDetection from '@tensorflow-models/pose-detection';
  import axios from 'axios';
  export default {
    name: 'PoseDetectionComponent',
    data() {
      return {
        detector: null,
        video: null,
        canvas: null,
        ctx: null,
        isPoseDetected: false,
        isFrontCaptured: false, // 是否已经拍摄正面照
        canvasWidth: window.innerWidth, // 初始化为窗口宽度
        canvasHeight: window.innerHeight, // 初始化为窗口高度
        windowWidth: window.innerWidth, // 窗口宽度
        windowHeight: window.innerHeight, // 窗口高度
        frontImg:'',//正面照
        sideImg:'',//侧面照
        isCompleted:false, // 任务是否已完成
        showVideo:true, // 初始为 true，表示开始检测
        imageUrl:'',
        text: '',
        video2:require('@/assets/fitting.mp4'),
        leftWrist:'',
        rightWrist:''
      };
    },
    async mounted() {
        // setTimeout(() => {
        //     this.$emit('updateState', {
        //         type: 'front',  
        //         imgUrl: ''
        //         });
        //         setTimeout(() => {
        //             this.$emit('updateState', {
        //         type: 'side',  
        //         imgUrl: ''
        //         });
        //         }, 3000);
        // }, 3000);
        this.video = this.$refs.video;
        this.canvas = this.$refs.canvas;
        this.windowWidth = window.innerWidth, // 窗口宽度
        this.windowHeight = window.innerHeight, // 窗口高度
        await this.setupCamera();
        
        // window.addEventListener('resize', this.resizeCanvas);
        // this.resizeCanvas(); // 初始化时调整画布大小
        this.detector = await poseDetection.createDetector(poseDetection.SupportedModels.MoveNet);
        this.ctx = this.$refs.canvas.getContext('2d');
        this.detectPose();
        
    },
    methods: {
      // 设置摄像头
      async setupCamera() {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.video.srcObject = stream;
        return new Promise((resolve) => {
          this.video.onloadedmetadata = () => {
            const videoWidth = this.$refs.video.videoWidth; // 视频的实际宽度
            const videoHeight = this.$refs.video.videoHeight; // 视频的实际高度
            console.log('Video Resolution:', videoWidth, videoHeight);
            const rect = this.$refs.video.getBoundingClientRect();
            const renderedWidth = rect.width; // 渲染后的宽度
            const renderedHeight = rect.height; // 渲染后的高度
            this.$refs.canvas.width = videoWidth;
            this.$refs.canvas.height = videoHeight;
            console.log('Rendered Size:', renderedWidth, renderedHeight);
            resolve();
        };
        });
      },
  
      // 检测姿势
      async detectPose() {
        const poses = await this.detector.estimatePoses(this.video);
        this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        this.ctx.drawImage(this.video, 0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        if (poses.length > 0) {
          const pose = poses[0];
          // this.drawKeypoints(pose.keypoints);
  
          // 判断是否满足条件
          if (!this.isFrontCaptured) {
            // 检测正面照
            if (this.checkFrontPose(pose.keypoints)) {
              this.isPoseDetected = true;
              this.captureImage('front');
              this.isFrontCaptured = true;
            }
          } else {
            // 检测侧面照
            if (this.checkSidePose(pose.keypoints)) {
              this.isPoseDetected = true;
              this.captureImage('side');
              this.isFrontCaptured = false; // 重置状态，以便下次拍摄
            }
          }
        }
  
        requestAnimationFrame(this.detectPose);
        // setTimeout(() => {
        // }, 100); // 每 100ms 检测一次
      },
  
      // 绘制关键点
      drawKeypoints(keypoints) {
        keypoints.forEach((keypoint) => {
          if (keypoint.score > 0.5) {
            this.ctx.beginPath();
            this.ctx.arc(keypoint.x, keypoint.y, 5, 0, 2 * Math.PI);
            this.ctx.fillStyle = 'red';
            this.ctx.fill();
          }
        });
  
        // 绘制连线
        const connections = [
          ['left_shoulder', 'right_shoulder'], // 肩部连线
          ['left_shoulder', 'left_elbow'], // 左肩到左肘
          ['right_shoulder', 'right_elbow'], // 右肩到右肘
          ['left_elbow', 'left_wrist'], // 左肘到左手腕
          ['right_elbow', 'right_wrist'], // 右肘到右手腕
          ['left_shoulder', 'left_hip'], // 左肩到左臀
          ['right_shoulder', 'right_hip'], // 右肩到右臀
          ['left_hip', 'right_hip'], // 臀部连线
        ];
  
        connections.forEach(([start, end]) => {
          const startPoint = keypoints.find((kp) => kp.name === start);
          const endPoint = keypoints.find((kp) => kp.name === end);
  
          if (startPoint && endPoint && startPoint.score > 0.5 && endPoint.score > 0.5) {
            this.ctx.beginPath();
            this.ctx.moveTo(startPoint.x, startPoint.y);
            this.ctx.lineTo(endPoint.x, endPoint.y);
            this.ctx.strokeStyle = 'green';
            this.ctx.lineWidth = 2;
            this.ctx.stroke();
          }
        });
      },
      coordinateConversion(keypoint){
        let keypoint_x = keypoint.x
        let keypoint_y = keypoint.y
        keypoint.x = this.$refs.canvas.width - keypoint_y
        keypoint.y = keypoint_x
        return keypoint
      },
      // 判断正面姿势是否满足条件
      checkFrontPose(keypoints) {
        const leftShoulder = keypoints.find((kp) => kp.name === 'left_shoulder');
        const leftShoulder_new = this.coordinateConversion(leftShoulder);
        const rightShoulder = keypoints.find((kp) => kp.name === 'right_shoulder');
        const rightShoulder_new = this.coordinateConversion(rightShoulder);
        const leftElbow = keypoints.find((kp) => kp.name === 'left_elbow');
        const leftElbow_new = this.coordinateConversion(leftElbow);
        const rightElbow = keypoints.find((kp) => kp.name === 'right_elbow');
        const rightElbow_new = this.coordinateConversion(rightElbow);
        const leftWrist = keypoints.find((kp) => kp.name === 'left_wrist');
        const leftWrist_new = this.coordinateConversion(leftWrist);
        const rightWrist = keypoints.find((kp) => kp.name === 'right_wrist');
        const rightWrist_new = this.coordinateConversion(rightWrist);
        console.log(leftShoulder_new)
        console.log(rightShoulder_new)
        console.log(leftElbow_new)
        console.log(rightElbow_new)
        console.log(leftWrist_new)
        console.log(rightWrist_new)
        if (!leftShoulder_new || !rightShoulder_new || !leftElbow_new || !rightElbow_new || !leftWrist_new || !rightWrist_new) {
          return false;
        }
  
        // 计算双臂的角度
        const leftArmAngle = this.calculateAngle1(leftShoulder_new, leftWrist_new);
        const rightArmAngle = this.calculateAngle1(rightShoulder_new, rightWrist_new);
        //计算肩膀两点与水平的夹角，辅助判断是否正面直立
        const shoulderAngle = this.calculateAngle(leftShoulder_new, rightShoulder_new);
  
        // 判断双臂是否张开约 45 度
        const isArmsOpen =
          Math.abs(leftArmAngle - 45) < 25 && Math.abs(rightArmAngle - 45) < 10;
  
        // 判断是否正面站立（肩部水平线倾斜）增加了正面的判断
        const isFrontFacing =
          Math.abs(shoulderAngle-5) < 5 && leftWrist_new.x > rightWrist_new.x;

        console.log('leftArmAngle',leftArmAngle)
        console.log('rightArmAngle',rightArmAngle)
        console.log('shoulderAngle',shoulderAngle)
        console.log('isArmsOpen',isArmsOpen)
        
  
        return isArmsOpen && isFrontFacing;
      },
      
      // 判断侧面姿势是否满足条件
      checkSidePose(keypoints) {
          const leftShoulder = keypoints.find((kp) => kp.name === 'left_shoulder');
          const leftShoulder_new = this.coordinateConversion(leftShoulder);
          const rightShoulder = keypoints.find((kp) => kp.name === 'right_shoulder');
          const rightShoulder_new = this.coordinateConversion(rightShoulder);

          const leftHip = keypoints.find(k => k.name === 'left_hip');
          const leftHip_new = this.coordinateConversion(leftHip);
          const rightHip = keypoints.find(k => k.name === 'right_hip');
          const rightHip_new = this.coordinateConversion(rightHip);

          if (leftShoulder_new && rightShoulder_new && leftHip_new && rightHip_new) {
            const shoulderDistance = Math.abs(leftShoulder_new.x - rightShoulder_new.x);
            const shoulderhipDistance = Math.abs(leftHip_new.y - leftShoulder_new.y);
            const shoulderhipScale = shoulderhipDistance/shoulderDistance;
            //判断人是否直立
            const leftAngle = this.calculateAngle1(leftShoulder_new,leftHip_new);
            const rightAngle = this.calculateAngle1(rightShoulder_new,rightHip_new);
            const isUpright = Math.abs(leftAngle-10) < 5 && Math.abs(rightAngle-10) < 5;

            if (shoulderhipScale > 3 && isUpright) {
              console.log('侧身姿势');
              return true;
            }
          }
        },
        calculateAngle1(pointA, pointB) {
          const dx = pointB.x - pointA.x;
          const dy = pointB.y - pointA.y;
            // 计算两点之间的连线与竖直线的夹角
            let angle = Math.abs((Math.atan2(dx, dy) * 180) / Math.PI);
            if (angle > 90){
              angle = 180 - angle;
            }
            return angle;
        },
        // 计算两点之间的角度（与水平线的夹角）
        calculateAngle(pointA, pointB) {
          const dx = pointB.x - pointA.x;
          const dy = pointB.y - pointA.y;
          // 计算两点之间的连线与水平线的夹角
          let angle = Math.abs((Math.atan2(dy, dx) * 180) / Math.PI);
          if (angle > 90){
            angle = 180 - angle;
          }
          return angle;
        },
        async captureImage(type) {
          if (this.isCompleted) {
              console.log('任务已完成，无法拍照');
              return; // 如果任务已完成，停止检测
          }

          // 获取原始图像的Base64字符串
          const base64Image = this.$refs.canvas.toDataURL('image/png').split(',')[1];

          // 创建一个新的Image对象
          const img = new Image();
          img.src = `data:image/png;base64,${base64Image}`;

          // 等待图片加载完成
          await new Promise((resolve) => {
              img.onload = resolve;
          });

          // 创建一个新的Canvas元素
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // 设置Canvas的宽度和高度为旋转后的尺寸
          canvas.width = img.height;
          canvas.height = img.width;

          // 旋转图片90°
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(Math.PI / 2);
          ctx.drawImage(img, -img.width / 2, -img.height / 2);

          // 获取旋转后的Base64图像
          const rotatedBase64Image = canvas.toDataURL('image/png').split(',')[1];

          // 将旋转后的图像转换为Blob
          const response = await fetch(`data:image/png;base64,${rotatedBase64Image}`);
          const blob = await response.blob();

          // 创建FormData对象并添加文件
          const formData = new FormData();
          formData.append('file', blob, `pose_capture_${type}.png`); // 'file' 是后端接口接收文件的字段名

          // 使用 axios 发送请求
          axios.post('https://yiqingup.147.baiyunkj.cn/api/index/upload', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data', // 设置请求头
              },
          })
          .then((response) => {
              this.$emit('updateState', {
                  type: type,  
                  imgUrl: response.data.url
              });
          })
          .catch((error) => {
              alert('上传失败: ' + error.message);
          });
          if(type == 'front'){
              this.frontImg = `data:image/png;base64,${base64Image}`;
            } else {
              this.sideImg = `data:image/png;base64,${base64Image}`;
              this.isCompleted = true; // 任务已完成
              await this.setupCamera();
              this.detector = await poseDetection.createDetector(poseDetection.SupportedModels.MoveNet);
              this.ctx = this.$refs.canvas.getContext('2d');
            // this.detectPose();
            }
        },
       // 调整画布大小以匹配视频和窗口尺寸
        resizeCanvas() {
            const videoWidth = this.video.videoWidth;
            const videoHeight = this.video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;
            // if (window.innerWidth / window.innerHeight > aspectRatio) {
            //     width = window.innerHeight * aspectRatio;
            //     height = window.innerHeight;
            // } else {
            //     width = window.innerWidth;
            //     height = window.innerWidth / aspectRatio;
            // }
            this.canvas.width = this.$refs.video.width;
            this.canvas.height = this.$refs.video.height;
        },
        // 上传图片
        uploadImage(file){
            const formData = new FormData();
            formData.append('file', file); // 'file' 是后端接口接收文件的字段名
    
            // 使用 axios 发送请求
            axios.post('http://yiqingup.147.baiyunkj.cn/api/index/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // 设置请求头
                },
            })
            .then((response) => {
                // this.uploadResult = '上传成功: ' + JSON.stringify(response.data);
                })
                .catch((error) => {
                alert('上传失败: ' + error.message)
            });
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeCanvas);
    }
  };
  </script>
  
  <style scoped>
  /* .video-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
} */
  video, canvas {
      position: absolute;
      top: 1.61rem;
      left: 0;
      transform: scaleX(-1); 
      width: 100%;
    height: 100%;
    object-fit: cover; 
      /* z-index: 999; */
      top: calc(50vh - 50vw);
    left:calc(-1 * calc(50vh - 50vw));
    width: 100vh;
    height: 100vw;
    object-fit: cover;
    background: #000;
    transform: rotate(90deg); 
    }
    .alert {
      position: absolute;
      top: 2rem;
      left: 20px;
      background: rgba(0, 255, 0, 0.7);
      padding: 10px;
      color: white;
      font-size: 16px;
    }
  </style>